import type { ExperimentWithVerdict } from '@@/api/experiments/implementation-verdict';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { MoreHorizontal, Send, Download, ExternalLink } from 'lucide-react';
import { EmailDialog } from './EmailDialog';
import { exportImplementationCsv } from './export-csv';

type ImplementationActionsCellProps = {
  // Carries the verdict because the row's own CSV export reports the result too.
  experiment: ExperimentWithVerdict;
  /** Set on the first row only, for the product tour. */
  tourAnchor?: string;
};

export const ImplementationActionsCell = ({ experiment, tourAnchor }: ImplementationActionsCellProps) => {
  const [emailOpen, setEmailOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            data-tour={tourAnchor}
            className="border-line text-dim hover:text-foreground hover:bg-hover flex size-8 items-center justify-center rounded-lg border bg-transparent transition-colors duration-150"
          >
            <span className="sr-only">Open actions</span>
            <MoreHorizontal className="size-3.5" strokeWidth={1.5} />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-panel border-line rounded-card border">
          <DropdownMenuLabel className="micro-label">Actions</DropdownMenuLabel>
          <DropdownMenuItem className="text-meta" onClick={() => navigate(`/experiments/${experiment.id}`)}>
            <ExternalLink className="mr-2 size-3.5" strokeWidth={1.5} />
            View Experiment
          </DropdownMenuItem>
          <DropdownMenuItem className="text-meta" onClick={() => setEmailOpen(true)}>
            <Send className="mr-2 size-3.5" strokeWidth={1.5} />
            Email Details
          </DropdownMenuItem>
          <DropdownMenuSeparator className="bg-line" />
          <DropdownMenuItem className="text-meta" onClick={() => exportImplementationCsv([experiment])}>
            <Download className="mr-2 size-3.5" strokeWidth={1.5} />
            Export CSV
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <EmailDialog open={emailOpen} onOpenChange={setEmailOpen} experiment={experiment} />
    </>
  );
};
